import { render, staticRenderFns } from "./Registros.vue?vue&type=template&id=3be806d9&"
import script from "./Registros.vue?vue&type=script&lang=js&"
export * from "./Registros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports